import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { api } from '../services/api';
import { getProjectUrl } from '../lib/slug';

/**
 * Redirect component for old /property/:id URLs
 * Fetches the project by ID and redirects to the slug-based URL
 */
export function PropertyRedirect() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    const redirectToSlug = async () => {
      if (!id) {
        navigate('/marketplace', { replace: true });
        return;
      }

      try {
        // Determine if we should treat id as number or string for the API
        const queryId = /^\d+$/.test(id) ? parseInt(id) : id;
        const property = await api.properties.get(queryId);

        if (property) {
          // Redirect to slug-based URL
          const slugUrl = getProjectUrl(property);
          navigate(slugUrl, { replace: true });
        } else {
          // Property not found, redirect to marketplace
          navigate('/marketplace', { replace: true });
        }
      } catch (err) {
        console.error('[PropertyRedirect] Error fetching property:', err);
        // On error, redirect to marketplace
        navigate('/marketplace', { replace: true });
      }
    };

    redirectToSlug();
  }, [id, navigate]);

  // Show loading while redirecting
  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <Loader2 size={40} className="animate-spin text-slate-300" />
    </div>
  );
}
